import React from 'react'
import { SearchOutlined, UserAddOutlined } from '@ant-design/icons'
import styled from 'styled-components/macro'

const AddSupplierHub = ({ onFindOnOms, onInvite }) => (
  <Hub>
    <HubCard type='button' onClick={onFindOnOms}>
      <HubIconWrap>
        <SearchOutlined />
      </HubIconWrap>
      <HubTitle>Find on OMS</HubTitle>
      <HubDescription>
        Search suppliers already on OMS and connect instantly.
      </HubDescription>
    </HubCard>

    <HubCard type='button' onClick={onInvite}>
      <HubIconWrap>
        <UserAddOutlined />
      </HubIconWrap>
      <HubTitle>Invite new supplier</HubTitle>
      <HubDescription>
        Supplier not on OMS? We&apos;ll email them to join so you can start
        ordering.
      </HubDescription>
    </HubCard>
  </Hub>
)

const Hub = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  max-width: 640px;
  margin: 24px auto 0;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

const HubCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 16px;
  background: #fff;
  border: 1px solid ${({ theme }) => theme.colours?.lettuceGreen || '#b5d922'};
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    background-color: #fafff0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme }) => theme.colours?.lettuceGreen || '#b5d922'};
    outline-offset: 2px;
  }
`

const HubIconWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #f6ffed;
  color: #262626;
  font-size: 22px;
  margin-bottom: 12px;
`

const HubTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #262626;
  margin: 0 0 8px;
`

const HubDescription = styled.p`
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.5;
  margin: 0;
`

export default AddSupplierHub
